import * as Yup from 'yup';

const validatePhoneNumber = (phoneNumber) => {
  const pattern = /^[2-9]{1}[1-9]{1}[0-9]{8}$/;
  if (phoneNumber && phoneNumber.length > 0) return phoneNumber.match(pattern) ? true : false;
  return true;
};

const isSecurePassword = (password) => {
  if (password) {
    const strengthResults = [
      /[A-Z]/.test(password),
      /[0-9]/.test(password),
      /[!-/:-@[-`{-~]/.test(password),
      password.length >= 8,
    ];

    const valid =
      strengthResults.reduce((accumulator, currentValue) => accumulator + currentValue, 0) ===
      strengthResults.length;

    if (!valid) {
      return false;
    }

    return true;
  }

  return false;
};

Yup.addMethod(Yup.string, 'phone', function (message) {
  message = message || 'Ingrese un número de teléfono válido';
  return this.test(`test-phone`, message, function (value) {
    const { path, createError } = this;
    if (!validatePhoneNumber(value)) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'password', function (errorMessage) {
  return this.test(`test-password`, errorMessage, function (value) {
    const { path, createError } = this;
    if (!isSecurePassword(value)) {
      return createError({ path, message: errorMessage });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'validUrl', function (label) {
  const validateURL = (url) => /^https?:\/\/.+/.test(url) || /^[\w.-]+\.[a-zA-Z]{2,}/.test(url);

  return this.test('valid-url', 'URL inválida', function (value) {
    const { path, createError } = this;
    if (value && !validateURL(value))
      return createError({ path, message: `URL${label ? ` de ${label}` : ''} inválida` });
    return true;
  });
});

// Si usas AND debe haber las mismas keys y values
Yup.addMethod(Yup.mixed, 'whenCM', function (requiredSchema, key = [], values = [], type = 'or') {
  if (!Array.isArray(values)) values = [values];
  if (!Array.isArray(key)) key = [key];
  type = type.toLowerCase();
  const keyL = key.length;

  const validTypes = ['or', 'and'];
  if (!validTypes.includes(type)) type = 'or';

  if (type === 'and' && keyL !== values.length)
    return this.test('whenCM', 'Parametros distintos key y values', () => false);

  return this.when(key, (...args) => {
    const schema = args[keyL];
    const keys = args.slice(0, keyL);

    const conditionMet = (() => {
      if (type === 'and') return keys.every((k, index) => values[index] === keys[index]);
      return keys.some((k, index) =>
        keyL === 1 ? values.includes(keys[index]) : values[index] === keys[index]
      );
    })();

    if (conditionMet) return requiredSchema.required().label(schema?.spec?.label || '');
    return schema.optional().nullable();
  });
});

/* ejemplo AND

status: Yup.string().whenCM(
    Yup.string().min(3),
    ['esConcurrente', 'TienePreregistro'],  // Las claves a observar
    [     true      ,         1         ],  // Los valores que deben coincidir con las claves
    'and'
  ),
*/

let Yupi18n = Yup;
/* eslint-disable */
Yupi18n.setLocale({
  mixed: {
    default: '${path} es invalido',
    required: '${path} es requerido',
    oneOf: '${path} debe ser una de las opciones: ${values}',
    notOneOf: '${path} no debe ser una de las opciones: ${values}',
  },
  string: {
    length: '${path} debe ser exactamente ${length} caracteres',
    min: '${path} debe tener al menos ${min} caracteres',
    max: '${path} debe tener máximo ${max} caracteres',
    matches: '${path} debe ser parecido a: "${regex}"',
    email: '${path} debe ser un correo electrónico válido',
    url: '${path} debe ser una URL válida',
    uuid: '${path} debe ser un UUID válido',
    trim: '${path} no debe contener espacios al inicio ni al final',
    lowercase: '${path} debe estar en minúsculas',
    uppercase: '${path} debe estar en mayúsculas',
  },
  number: {
    min: '${path} debe ser mayor o igual a ${min}',
    max: '${path} debe ser menor o igual ${max}',
    lessThan: '${path} debe ser menor a ${less}',
    moreThan: '${path} debe ser mayor a ${more}',
    positive: '${path} debe ser un número positivo',
    negative: '${path} debe ser un número negativo',
    integer: '${path} debe ser un número entero',
  },
  date: {
    min: '${path} debe ser después de ${min}',
    max: '${path} debe ser antes de ${max}',
  },
  boolean: {
    isValue: '${path} debe ser ${value}',
  },
  array: {
    min: '${path} debe tener al menos ${min} elementos',
    max: '${path} debe tener máximo ${max} elementos',
    length: '${path} debe tener ${length} elementos',
  },
});
/* eslint-enable */

export default Yupi18n;
